import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { copilotMessagePublisherEnvironment } from '../copilot-message-publisher-environment';
import { messageHistorySchema } from '../schemas/message-history';

/**
 * Gets the message history for the given user
 * @param userId The user id to get the message history for
 * @returns An array of MessageHistory objects
 */
export function getUsersMessages(this: unknown, userId: string) {
  return fromFetch(
    new Request(
      copilotMessagePublisherEnvironment.resolve(this).usersMessagesUrl(userId),
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
      }
    )
  ).pipe(selectData(z.array(messageHistorySchema)));
}
